import { render, staticRenderFns } from "./sleepImprovementGuidance.vue?vue&type=template&id=1ea0f1c8&"
import script from "./sleepImprovementGuidance.vue?vue&type=script&lang=js&"
export * from "./sleepImprovementGuidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports